var _desc, _defs, _rect, _g, _g2, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudCicd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 360",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Cloud Deployment CI CD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Cloud with pipeline arrows representing continuous delivery.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0f3658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#051728"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    rx: 18,
    fill: "url(#bg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1e709f"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 160,
    r: 54
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 316,
    cy: 128,
    r: 64
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 158,
    r: 52
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 160,
    width: 230,
    height: 62,
    rx: 30
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#ffd700",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130 264h86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242 264h84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352 264h84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 264l-12-12m12 12l-12 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326 264l-12-12m12 12l-12 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436 264l-12-12m12 12l-12 12"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 248,
    width: 334,
    height: 32,
    rx: 16,
    fill: "#0a2d49",
    stroke: "#6ec4ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudCicd);
export default __webpack_public_path__ + "static/media/cloud-cicd.938c5446072f8317f2e2be907917ceb6.svg";
export { ForwardRef as ReactComponent };